module.exports = __webpack_public_path__ + "img/11.6bedb676.png";